module.exports = __webpack_public_path__ + "assets/clear.03d821b8.svg";